<section class="summary-sect" *ngIf="!isViewOrder; else view">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 chk-frm">
        <div class="trip-summary col-first">
          <div class="evt-htl-summary">
            <div class="evt" *ngIf="loadedEventFlag">
              <div class="evt-head">
                <h5 class="float:left">
                  <img src="assets/svg-pages/EventTicket.svg" />
                <b>{{"summaryCard.evt" | i18n}}</b>
                </h5>
                <a class="add-evt" (click)="openPopupevt()">{{"summaryCard.btnAddEvent" | i18n}}</a>
              </div>
              <div *ngFor="let data of loadedEvent">
                <tic-event-summary-card
                  [eventResult]="data"
                  [eventCount]="eventCount"
                  (eventSelection)="eventsUpdate($event)"
                ></tic-event-summary-card>
              </div>
            </div>
            <ng-container  *ngIf="!loadedEventFlag">
              <tic-event-result-card-skeleton [rpp]="1" [totalLeftToFetch]="10"></tic-event-result-card-skeleton>
            </ng-container>
            <div class="htl" *ngIf="loadedHotelFlag">
              <div class="evt-head flt">
                <h5 class="float:left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      d="M4.5 31.5H7.5M7.5 31.5H15M7.5 31.5V4.5M15 31.5H21M15 31.5V24H12C15 20 21 20 24 24H21V31.5M7.5 4.5H4.5M7.5 4.5H28.5M21 31.5H28.5M28.5 31.5H31.5M28.5 31.5V4.5M28.5 4.5H31.5M13.5 9.75H15M21 9.75H22.5M13.5 15.75H15M21 15.75H22.5"
                      stroke="black"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg><b>{{"summaryCard.hotel" | i18n}}</b>
                </h5>
              </div>
              <div class="seatcard">
                <div class="main-img">
                  <img [src]="this.loadedHotel.images?this.loadedHotel.images[0].url:'assets/images/no-hotel.jpg'" />
                </div>
                <div class="seat-crd-content">
                  <h2>{{ this.loadedHotel.name }}</h2>
                  <p>
                    <tic-hotel-stars [rating]="this.loadedHotel.starsRating?this.loadedHotel.starsRating.code[0]:this.loadedHotel.categoryCode?this.loadedHotel.categoryCode[0]:''" [starCount]="this.loadedHotel.starsRating?this.loadedHotel.starsRating.code[0]:this.loadedHotel.categoryCode?this.loadedHotel.categoryCode[0]:''"></tic-hotel-stars>                  
                  </p>
                  <p *ngIf="loadedHotel.address">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                    >
                      <path
                        d="M8.36841 7C8.92069 7 9.36841 6.55228 9.36841 6C9.36841 5.44772 8.92069 5 8.36841 5C7.81612 5 7.36841 5.44772 7.36841 6C7.36841 6.55228 7.81612 7 8.36841 7Z"
                        fill="black"
                      />
                      <path
                        d="M8.36841 1C5.61153 1 3.36841 3.14531 3.36841 5.78125C3.36841 7.03656 3.9406 8.70594 5.06903 10.7431C5.97528 12.3787 7.02372 13.8578 7.56903 14.5938C7.66118 14.7195 7.78166 14.8218 7.9207 14.8923C8.05975 14.9627 8.21345 14.9995 8.36935 14.9995C8.52524 14.9995 8.67894 14.9627 8.81799 14.8923C8.95703 14.8218 9.07751 14.7195 9.16966 14.5938C9.71403 13.8578 10.7634 12.3787 11.6697 10.7431C12.7962 8.70656 13.3684 7.03719 13.3684 5.78125C13.3684 3.14531 11.1253 1 8.36841 1ZM8.36841 8C7.97285 8 7.58617 7.8827 7.25727 7.66294C6.92837 7.44318 6.67202 7.13082 6.52065 6.76537C6.36927 6.39991 6.32967 5.99778 6.40684 5.60982C6.48401 5.22186 6.67449 4.86549 6.95419 4.58579C7.2339 4.30608 7.59027 4.1156 7.97823 4.03843C8.36619 3.96126 8.76832 4.00087 9.13377 4.15224C9.49923 4.30362 9.81158 4.55996 10.0313 4.88886C10.2511 5.21776 10.3684 5.60444 10.3684 6C10.3678 6.53026 10.1569 7.03863 9.78198 7.41357C9.40703 7.78852 8.89866 7.99942 8.36841 8Z"
                        fill="black"
                      />
                    </svg>
                    {{ loadedHotel.address.city }},
                    {{ loadedHotel.address.street }}, No:{{
                      loadedHotel.address.buildingNumber
                    }}, {{ loadedHotel.address.country }}
                    {{ loadedHotel.address.postalCode }}
                  </p>
                  <div class="brk-line">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="842"
                      height="2"
                      viewBox="0 0 842 2"
                      fill="none"
                    >
                      <path
                        opacity="0.33"
                        d="M0.605957 1H841.311"
                        stroke="black"
                      />
                    </svg>
                  </div>
                  <p *ngIf="selectedRoom; else roomDiv">
                    <b>{{ selectedRoom.name }}</b> <br />
                    <span>
                      Board Type - {{ selectedRoom.boardName }}</span
                    >
                  </p>
                  <ng-template #roomDiv>
                    <p *ngIf="this.loadedHotel.rooms[0]">
                      <b>{{ this.loadedHotel.rooms[0].name }}</b> <br />
                      <span>
                        Board Type - {{ this.loadedHotel.rooms[0].rates[0].boardName }}</span
                      >
                    </p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="flight" *ngIf="loadedFlightFlag">
              <div class="evt-head flt">
                <h5 class="float:left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 39 40"
                    fill="none"
                  >
                    <path
                      d="M26.6628 7.60909C27.9983 6.27353 30.1637 6.27353 31.4992 7.60909C32.8347 8.94464 32.8347 11.11 31.4992 12.4455L27.4689 16.4759L30.4728 28.464C30.6096 29.0102 30.4515 29.5884 30.0557 29.989L29.6656 30.3838C28.9478 31.1104 27.7439 30.9948 27.1774 30.145L21.8263 22.1185L15.3777 28.5671V31.9297C15.3777 32.3572 15.2079 32.7674 14.9055 33.0696L14.452 33.5231C13.7003 34.2749 12.4397 34.1059 11.9123 33.1831L9.73518 29.3731L5.92526 27.1961C5.00231 26.6686 4.83348 25.4081 5.58515 24.6563L6.03869 24.2028C6.34102 23.9005 6.75109 23.7306 7.17865 23.7306H10.5413L16.9899 17.282L8.96336 11.931C8.11357 11.3645 7.99804 10.1605 8.72462 9.44273L9.1196 9.05253C9.52018 8.65678 10.0982 8.49872 10.6445 8.63559L22.6324 11.6395L26.6628 7.60909Z"
                      stroke="black"
                      stroke-width="2.96975"/></svg><b>{{"summaryCard.flights" | i18n}}</b>
                </h5>
                <div class="btns" >
                  <button class="btn" (click)="luggagepopup()">
                    {{"summaryCard.btnAddLaggage" | i18n}}
                  </button>
                  <button class="btn" (click)="openPopup()">
                    {{"summaryCard.btnChangeFlight" | i18n}}
                  </button>
                </div>
              </div>
              <tic-flight-result
                [flightOffer]="loadedFlight"
                [parseDuration]="parseDuration"
                [parseLocation]="parseLocation"
                [showBookingButton]="false"
                [isSummary]="true"
              >
              </tic-flight-result>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-4 sum-frm">
        <tic-summary-card [showCheckout]="true" (checkoutClick)="onSelectCheckout()"></tic-summary-card>
      </div>
    </div>
  </div>
</section>
<ng-template #view>
  <div class="container" *ngIf="!orderDetail.error; else error">
    <div class="row">
      <div class="col-lg-8 chk-frm">
        <div class="trip-summary col-first">
          <div class="evt-htl-summary">
            <div class="evt" *ngIf="loadedEventFlag">
              <div class="evt-head">
                <h5 class="float:left">
                  <img src="assets/svg-pages/EventTicket.svg" />
                <b>{{"summaryCard.evt" | i18n}}</b>
                </h5>
              </div>
              <div *ngFor="let data of loadedEvent">
                <tic-event-summary-card
                  [eventResult]="data"
                  [eventCount]="eventCount"
                  (eventSelection)="eventsUpdate($event)"
                ></tic-event-summary-card>
              </div>
            </div>
            <div  *ngIf="!loadedEventFlag">
              <tic-event-result-card-skeleton [rpp]="1" [totalLeftToFetch]="10"></tic-event-result-card-skeleton>
            </div>
            <div class="htl" *ngIf="loadedHotelFlag">
              <div class="evt-head flt">
                <h5 class="float:left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      d="M4.5 31.5H7.5M7.5 31.5H15M7.5 31.5V4.5M15 31.5H21M15 31.5V24H12C15 20 21 20 24 24H21V31.5M7.5 4.5H4.5M7.5 4.5H28.5M21 31.5H28.5M28.5 31.5H31.5M28.5 31.5V4.5M28.5 4.5H31.5M13.5 9.75H15M21 9.75H22.5M13.5 15.75H15M21 15.75H22.5"
                      stroke="black"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg><b>{{"summaryCard.hotel" | i18n}}</b>
                </h5>
              </div>
              <div class="seatcard">
                <div class="main-img">
                  <img [src]="this.loadedHotel.images?this.loadedHotel.images[0].url:'assets/images/no-hotel.jpg'" />
                </div>
                <div class="seat-crd-content">
                  <h2>{{ this.loadedHotel.name }}</h2>
                  <p>
                    <tic-hotel-stars [rating]="this.loadedHotel.starsRating?this.loadedHotel.starsRating.code[0]:this.loadedHotel.categoryCode?this.loadedHotel.categoryCode[0]:''" [starCount]="this.loadedHotel.starsRating?this.loadedHotel.starsRating.code[0]:this.loadedHotel.categoryCode?this.loadedHotel.categoryCode[0]:''"></tic-hotel-stars>                  
                  </p>
                  <p *ngIf="loadedHotel.address">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                    >
                      <path
                        d="M8.36841 7C8.92069 7 9.36841 6.55228 9.36841 6C9.36841 5.44772 8.92069 5 8.36841 5C7.81612 5 7.36841 5.44772 7.36841 6C7.36841 6.55228 7.81612 7 8.36841 7Z"
                        fill="black"
                      />
                      <path
                        d="M8.36841 1C5.61153 1 3.36841 3.14531 3.36841 5.78125C3.36841 7.03656 3.9406 8.70594 5.06903 10.7431C5.97528 12.3787 7.02372 13.8578 7.56903 14.5938C7.66118 14.7195 7.78166 14.8218 7.9207 14.8923C8.05975 14.9627 8.21345 14.9995 8.36935 14.9995C8.52524 14.9995 8.67894 14.9627 8.81799 14.8923C8.95703 14.8218 9.07751 14.7195 9.16966 14.5938C9.71403 13.8578 10.7634 12.3787 11.6697 10.7431C12.7962 8.70656 13.3684 7.03719 13.3684 5.78125C13.3684 3.14531 11.1253 1 8.36841 1ZM8.36841 8C7.97285 8 7.58617 7.8827 7.25727 7.66294C6.92837 7.44318 6.67202 7.13082 6.52065 6.76537C6.36927 6.39991 6.32967 5.99778 6.40684 5.60982C6.48401 5.22186 6.67449 4.86549 6.95419 4.58579C7.2339 4.30608 7.59027 4.1156 7.97823 4.03843C8.36619 3.96126 8.76832 4.00087 9.13377 4.15224C9.49923 4.30362 9.81158 4.55996 10.0313 4.88886C10.2511 5.21776 10.3684 5.60444 10.3684 6C10.3678 6.53026 10.1569 7.03863 9.78198 7.41357C9.40703 7.78852 8.89866 7.99942 8.36841 8Z"
                        fill="black"
                      />
                    </svg>
                    {{ loadedHotel.address.city }},
                    {{ loadedHotel.address.street }}, No:{{
                      loadedHotel.address.buildingNumber
                    }}, {{ loadedHotel.address.country }}
                    {{ loadedHotel.address.postalCode }}
                  </p>
                  <div class="brk-line">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="842"
                      height="2"
                      viewBox="0 0 842 2"
                      fill="none"
                    >
                      <path
                        opacity="0.33"
                        d="M0.605957 1H841.311"
                        stroke="black"
                      />
                    </svg>
                  </div>
                  <p *ngIf="selectedRoom; else roomDiv">
                    <b>{{ selectedRoom.name }}</b> <br />
                    <span>
                      Board Type - {{ selectedRoom.boardName }}</span
                    >
                  </p>
                  <ng-template #roomDiv>
                    <p *ngIf="this.loadedHotel.rooms[0]">
                      <b>{{ this.loadedHotel.rooms[0].name }}</b> <br />
                      <span>
                        Board Type - {{ this.loadedHotel.rooms[0].rates[0].boardName }}</span
                      >
                    </p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="flight" *ngIf="loadedFlightFlag">
              <div class="evt-head flt">
                <h5 class="float:left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 39 40"
                    fill="none"
                  >
                    <path
                      d="M26.6628 7.60909C27.9983 6.27353 30.1637 6.27353 31.4992 7.60909C32.8347 8.94464 32.8347 11.11 31.4992 12.4455L27.4689 16.4759L30.4728 28.464C30.6096 29.0102 30.4515 29.5884 30.0557 29.989L29.6656 30.3838C28.9478 31.1104 27.7439 30.9948 27.1774 30.145L21.8263 22.1185L15.3777 28.5671V31.9297C15.3777 32.3572 15.2079 32.7674 14.9055 33.0696L14.452 33.5231C13.7003 34.2749 12.4397 34.1059 11.9123 33.1831L9.73518 29.3731L5.92526 27.1961C5.00231 26.6686 4.83348 25.4081 5.58515 24.6563L6.03869 24.2028C6.34102 23.9005 6.75109 23.7306 7.17865 23.7306H10.5413L16.9899 17.282L8.96336 11.931C8.11357 11.3645 7.99804 10.1605 8.72462 9.44273L9.1196 9.05253C9.52018 8.65678 10.0982 8.49872 10.6445 8.63559L22.6324 11.6395L26.6628 7.60909Z"
                      stroke="black"
                      stroke-width="2.96975"
                    /></svg><b>{{"summaryCard.flights" | i18n}}</b>
                </h5>
              </div>
              <tic-flight-result
                [flightOffer]="loadedFlight"
                [parseDuration]="parseDuration"
                [parseLocation]="parseLocation"
                [showBookingButton]="false"
                [isSummary]="true"
              >
              </tic-flight-result>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 sum-frm">
        <div class="trip-summary trip-summary-bg checkoutcard" *ngIf="facadeCheckout.orderInfo$ | async as orderInfo">
          <div class="summarycard" *ngIf="orderInfo?.ticketsOrders?.length > 0">
            <div class="headingcard">
              <img src="assets/images/ticket.png" alt="" width="" height="" />
              <h2>{{ 'summaryCard.evt' | i18n }}</h2>
            </div>
            <p *ngFor="let data of orderInfo?.ticketsOrders">{{ data?.name }}</p>
          </div>
          <div class="summarycard" *ngIf="orderInfo?.flightOrder && orderInfo.flightOrder.name?.trim()">
            <div class="headingcard">
              <img
                src="../../../../../assets/images/emptyflight.png"
                alt=""
                width=""
                height=""
              />
              <h2>{{"summaryCard.flights" | i18n}}</h2>
            </div>
            <p>{{ orderInfo?.flightOrder?.name }}</p>
          </div>
          <div class="summarycard" *ngIf="orderInfo.hotelOrder && orderInfo.hotelOrder.name?.trim()">
            <div class="headingcard">
              <img src="assets/images/hotel.png" alt="" width="" height="" />
              <h2>{{"summaryCard.hotel" | i18n}}</h2>
            </div>
            <p>
              {{ orderInfo?.hotelOrder?.name }}
            </p>
          </div>
          <div class="priceinclude">
            <h4><b></b></h4>
            <h4>
              <b *ngIf="orderInfo?.originPrice && orderInfo?.discountAmount > 0"
                >
                {{"summaryCard.orignalPrice" | i18n}}:
                <s>{{ orderInfo?.originPrice | currencyConverter123 | async }}</s>
              </b><br>
              <b *ngIf="orderInfo?.discountAmount"
                >{{"summaryCard.discountAmount" | i18n}}:
                {{ orderInfo?.discountAmount | currencyConverter123 | async }}
              </b><br>
              <b
                >{{"summaryCard.totalCost" | i18n}}:
                {{ orderInfo?.ourPrice | currencyConverter123 | async }}
              </b>
            </h4>
            <h4 class="border"><b></b></h4>

            <h4><b>{{"summaryCard.priceIncludes" | i18n}}</b></h4>
            <h4><b>{{ packageType[packageTypeId - 1] | i18n}}</b></h4>
            <button class="btn" (click)="onSelectCheckout()">
              {{"summaryCard.btnGoToCheckOut" | i18n}}
            </button>
            <p>
              {{"summaryCard.note" | i18n}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #error>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="seatcard">
            <p class="text-danger">Order Not Found.</p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<section [ngClass]="{ open: pickLuggage, luggage: true }">
  <div class="luggage-container">
    <div class="close-popup">
      <svg
        (click)="luggagepopup()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g _ngcontent-sml-c41="" opacity="0.5">
          <path
            _ngcontent-sml-c41=""
            d="M18 6L6 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            _ngcontent-sml-c41=""
            d="M6 6L18 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
    <div class="lugg-header">
      <h2>John Doe</h2>
      <p>Current baggage : 10KG</p>
    </div>
    <div class="luggage-body">
      <div class="luggage-options">
        <div [ngClass]="{ 'luggage-option': true }" (click)="selectopt($event)">
          <span _ngcontent-sml-c41="">+$0</span>
          <div class="luggage-image">
            <img src="assets/images/stop.png" >
          </div>
          <div class="luggage-content">
            <h2>0 Kg</h2>
            <p>No Additional</p>
          </div>
        </div>
        <div [ngClass]="{ 'luggage-option': true }" (click)="selectopt($event)">
          <span _ngcontent-sml-c41="">+$0</span>
          <div class="luggage-image">
            <img src="assets/images/luggage.png" >
          </div>
          <div class="luggage-content">
            <h2>5 Kg</h2>
            <p>No Additional</p>
          </div>
        </div>
        <div [ngClass]="{ 'luggage-option': true }" (click)="selectopt($event)">
          <span _ngcontent-sml-c41="">+$0</span>
          <div class="luggage-image">
            <img src="assets/images/bag-luggage.png" >
          </div>
          <div class="luggage-content">
            <h2>10 Kg</h2>
            <p>No Additional</p>
          </div>
        </div>
      </div>
    </div>
    <div class="cont-btn">
      <button (click)="luggagepopup()" class="cont-btn">Add Luggage</button>
    </div>
  </div>
</section>
<section
  *ngIf="isflightOpen"
  [ngClass]="{ luggage: true, 'flight-popup': true }"
  appOutside
  (click)="ClickedOut($event)"
>
  <div class="luggage-container">
    <div class="close-popup">
      <svg
        (click)="closePopup()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g _ngcontent-sml-c41="" opacity="0.5">
          <path
            _ngcontent-sml-c41=""
            d="M18 6L6 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            _ngcontent-sml-c41=""
            d="M6 6L18 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
    <div class="evt-head flt">
      <h5 class="float:left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="40"
          viewBox="0 0 39 40"
          fill="none"
        >
          <path
            d="M26.6628 7.60909C27.9983 6.27353 30.1637 6.27353 31.4992 7.60909C32.8347 8.94464 32.8347 11.11 31.4992 12.4455L27.4689 16.4759L30.4728 28.464C30.6096 29.0102 30.4515 29.5884 30.0557 29.989L29.6656 30.3838C28.9478 31.1104 27.7439 30.9948 27.1774 30.145L21.8263 22.1185L15.3777 28.5671V31.9297C15.3777 32.3572 15.2079 32.7674 14.9055 33.0696L14.452 33.5231C13.7003 34.2749 12.4397 34.1059 11.9123 33.1831L9.73518 29.3731L5.92526 27.1961C5.00231 26.6686 4.83348 25.4081 5.58515 24.6563L6.03869 24.2028C6.34102 23.9005 6.75109 23.7306 7.17865 23.7306H10.5413L16.9899 17.282L8.96336 11.931C8.11357 11.3645 7.99804 10.1605 8.72462 9.44273L9.1196 9.05253C9.52018 8.65678 10.0982 8.49872 10.6445 8.63559L22.6324 11.6395L26.6628 7.60909Z"
            stroke="black"
            stroke-width="2.96975"
          /></svg
        ><b>{{"summaryCard.flights" | i18n}}</b>
      </h5>
      <div class="full-screen">
        <span class="tooltiptext">{{"summaryCard.flightTooltip" | i18n}}</span>
        <span>{{"summaryCard.fullScreen" | i18n}}</span>
        <a (click)="NavigateTo('flight')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 12L17 7M17 7H13.25M17 7V10.75"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 12L7 17M7 17H10.75M7 17V13.25"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
            />
          </svg>
        </a>
      </div>
    </div>
    <div class="flight">
      <tic-flights-page *ngIf="isflightOpen" [isSummaryPage]="true"  (flightSummarySelection)="onSelectedFlight($event)"></tic-flights-page>
      <!-- <div *ngIf="flightFacade.vm$ | async as vm">
        <div>
          <div *ngIf="vm.loaded; else content" class="single-flight">
            <div
              *ngFor="
                let flightOffer of flightResults;
                let i = index;
                trackBy: trackById
              "
            >
              <tic-flight-result
                [flightOffer]="flightOffer"
                [parseDuration]="parseDuration"
                [parseLocation]="parseLocation"
                (onSelectedFlight)="onSelectedFlight($event)"
              >
              </tic-flight-result>
            </div>
          </div>
          <ng-template #content>
            <tic-loader></tic-loader>
          </ng-template>
        </div>
      </div> -->
    </div>
  </div>
</section>

<section
  [ngClass]="{ luggage: true, 'event-popup': true, 'open': iseventOpen }"
  appOutside
  (click)="ClickedOutevt($event)"
>
  <div class="luggage-container">
    <div class="close-popup">
      <svg
        (click)="closePopupevt()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g _ngcontent-sml-c41="" opacity="0.5">
          <path
            _ngcontent-sml-c41=""
            d="M18 6L6 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            _ngcontent-sml-c41=""
            d="M6 6L18 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
    <div class="evt-head flt">
      <h5 class="float:left">
       <img src="assets/svg-pages/EventTicket.svg"/>
        <b>{{"summaryCard.evt" | i18n}}</b>
      </h5>
      <div class="full-screen">
        <span class="tooltiptext">{{"summaryCard.eventTooltip" | i18n}}</span>
        <span>{{"summaryCard.fullScreen" | i18n}}</span>
        <a (click)="NavigateTo('event')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 12L17 7M17 7H13.25M17 7V10.75"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 12L7 17M7 17H10.75M7 17V13.25"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8"
              stroke="black"
              stroke-width="1.6875"
              stroke-linecap="round"
            />
          </svg>
        </a>
      </div>
    </div>
    <div class="event">
      <tic-event-page *ngIf="iseventOpen" [isSummaryPage]="true" (eventSummarySelection)="eventSelection($event)"></tic-event-page>
      <div *ngIf="eventFacade.vm$ | async as vm">
        <div>
          <!-- <div *ngIf="vm.loaded; else content" class="single-flight">
            <div *ngFor="let data of vm.active">
              <ng-container *ngIf="!isEventLoaded(data.id)">
                <tic-event-result-card
                  *ngIf="data.tickets && data.tickets[0] != null"
                  [eventResult]="data"
                  (eventSelection)="eventSelection($event)"
                ></tic-event-result-card>
            </ng-container>
            </div>
          </div> -->
          <ng-template #content>
            <tic-loader></tic-loader>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>

